<template>
  <section class="ml-5">
    <div class="column is-12 box" v-if="hasCarfaxTesterRole === false && currentCarfaxRating">
      <section-header title="Overview" :collapsed="true"></section-header>
      <div class="columns is-multiline" v-if="hasCarfaxOverviewData">
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Purchase Date</label>
            <div class="field">
              <span>{{overviewVehiclePurchaseDate}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Vehicle Offered Date</label>
            <div class="field">
              <span>{{overviewLastVehicleOfferedForSaleDate}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Offered Source</label>
            <div class="field">
              <span>{{overviewLastVehicleOfferedForSaleSource}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Service Date</label>
            <div class="field">
              <span>{{overviewLastServiceDate}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Service Source</label>
            <div class="field">
              <span>{{overviewLastServiceSource}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Last Service Comments</label>
            <div class="field">
              <span>{{overviewLastServiceComments}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline" v-if="hasCarfaxOverviewData && currentCarfaxRating && isImportedVehicle">
        <div class="column is-4">
          <div class="field">
            <label class="label">Vehicle Imported Date</label>
            <div class="field">
              <span>{{overviewVehicleImportedDate}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Vehicle Imported Source</label>
            <div class="field">
              <span>{{overviewVehicleImportedSource}}</span>
            </div>
          </div>
        </div>
        <div class="column is-4">
          <div class="field">
            <label class="label">Vehicle Imported Comments</label>
            <div class="field">
              <span>{{overviewVehicleImportedComments}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="columns is-multiline" v-if="!hasCarfaxOverviewData">
        <div class="field" style="padding: 1em; margin-left: 15px;">
          <span>{{historyStatusMessage}}</span>
        </div>
      </div>
    </div>    
    <div class="column is-12 box"  v-else-if="hasCarfaxTesterRole === false && !currentCarfaxRating">
      <section-header title="Overview" :collapsed="true"></section-header>
      <div class="field" style="padding: 1em; margin-left: 15px;">
        <span>Overview information not available.</span>
      </div>
    </div>
  </section>
</template>

<script>

import ErrorDisplayComponent from '@/components/generic/ErrorDisplayComponent'
import SectionHeader from '@/components/generic/SectionHeader'
import inventoryService from '@/services/inventoryService'
import eventBus from '@/eventBus'
import _ from 'lodash'

import { createNamespacedHelpers } from 'vuex'
const mapUserGetters = createNamespacedHelpers('user').mapGetters

export default {
  name: 'CarfaxOverviewComponent',
  components: {
    'error-display-component': ErrorDisplayComponent,
    'section-header': SectionHeader
  },
  props: {
    inventoryItem: {
      type: Object,
      default: null
    },
    carFaxRating: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      instanceId: this.$uuid.v4(),
      currentInventory: null,
      currentCarfaxRating: null
    }
  },
  methods: {
    doInventoryLoad: _.debounce(function (query) { this.loadInventory(this.currentInventory.id) }, 500),
    loadInventory (id) {
      let that = this
      this.isLoading = true
      inventoryService.single(id).then(response => {
        that.currentCarfaxRating = response.inventory.carFaxRating
        that.isLoading = false
      }).catch((error) => {
        that.isLoading = false
      })
    },
    onCarfaxStatusChanged: function (notification) {
      let dataInventoryId = notification.data.inventoryId && notification.data.inventoryId > 0 ? notification.data.inventoryId : null
      let matchingInventoryId = this.currentInventory && this.currentInventory.id && dataInventoryId && dataInventoryId === this.currentInventory.id
      if (matchingInventoryId && notification.data && notification.data.requestStatus === 'CarfaxHistoryRequestCompleted') {
        this.doInventoryLoad()
      }
    }
  },
  computed: {
    ...mapUserGetters(['hasFeatureAccess', 'currentUser']),
    isImportedVehicle: function () {
      let result = false
      if (this.currentInventory && this.currentCarfaxRating && this.currentCarfaxRating.vehicleImportedDate) {
        result = true
      }
      if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.vehicleImportedDate) {
        result = true
      }
      return result
    },
    hasCarfaxOverviewData: function () {
      let result = false
      if ((this.currentInventory && this.currentCarfaxRating) && (this.currentCarfaxRating.vehiclePurchaseDate || this.currentCarfaxRating.lastVehicleOfferedForSaleDate || this.currentCarfaxRating.lastVehicleOfferedForSaleSource || this.currentCarfaxRating.lastServiceDate || this.currentCarfaxRating.lastServiceSource || this.currentCarfaxRating.lastServiceComments || this.currentCarfaxRating.vehicleImportedDate || this.currentCarfaxRating.vehicleImportedSource || this.currentCarfaxRating.vehicleImportedComments)) {
        result = true
      }
      if ((this.currentInventory && this.currentInventory.carFaxRating) && (this.currentInventory.carFaxRating.vehiclePurchaseDate || this.currentInventory.carFaxRating.lastVehicleOfferedForSaleDate || this.currentInventory.carFaxRating.lastVehicleOfferedForSaleSource || this.currentInventory.carFaxRating.lastServiceDate || this.currentInventory.carFaxRating.lastServiceSource || this.currentInventory.carFaxRating.lastServiceComments || this.currentInventory.carFaxRating.vehicleImportedDate || this.currentInventory.carFaxRating.vehicleImportedSource || this.currentInventory.carFaxRating.vehicleImportedComments)) {
        result = true
      }
      return result
    },
    hasCarfaxTesterRole: function () {
      if (this.currentUser && this.currentUser.roles) {
        return this.currentUser.roles.find((x) => { return x.name.toLowerCase().includes('carfax tester') }) !== undefined
      }
      return true
    },
    overviewVehiclePurchaseDate: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.vehiclePurchaseDate) {
        return this.$options.filters.formatDate(this.currentCarfaxRating.vehiclePurchaseDate)
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.vehiclePurchaseDate) {
         return this.$options.filters.formatDate(this.currentInventory.carFaxRating.vehiclePurchaseDate)
      }
      return '-'
    },
    overviewLastVehicleOfferedForSaleDate: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.lastVehicleOfferedForSaleDate) {
        return this.$options.filters.formatDate(this.currentCarfaxRating.lastVehicleOfferedForSaleDate)
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.lastVehicleOfferedForSaleDate) {
         return this.$options.filters.formatDate(this.currentInventory.carFaxRating.lastVehicleOfferedForSaleDate)
      }
      return '-'
    },
    overviewLastVehicleOfferedForSaleSource: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.lastVehicleOfferedForSaleSource) {
        return this.currentCarfaxRating.lastVehicleOfferedForSaleSource
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.lastVehicleOfferedForSaleSource) {
         return this.currentInventory.carFaxRating.lastVehicleOfferedForSaleSource
      }
      return '-'
    },
    overviewLastServiceDate: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.lastServiceDate) {
        return this.$options.filters.formatDate(this.currentCarfaxRating.lastServiceDate)
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.lastServiceDate) {
         return this.$options.filters.formatDate(this.currentInventory.carFaxRating.lastServiceDate)
      }
      return '-'
    },
    overviewLastServiceSource: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.lastServiceSource) {
        return this.currentCarfaxRating.lastServiceSource
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.lastServiceSource) {
         return this.currentInventory.carFaxRating.lastServiceSource
      }
      return '-'
    },
    overviewLastServiceComments: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.lastServiceComments) {
        return this.currentCarfaxRating.lastServiceComments
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.lastServiceComments) {
         return this.currentInventory.carFaxRating.lastServiceComments
      }
      return '-'
    },
    overviewVehicleImportedDate: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.vehicleImportedDate) {
        return this.$options.filters.formatDate(this.currentCarfaxRating.vehicleImportedDate)
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.vehicleImportedDate) {
         return this.$options.filters.formatDate(this.currentInventory.carFaxRating.vehicleImportedDate)
      }
      return '-'
    },
    overviewVehicleImportedSource: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.vehicleImportedSource) {
        return this.currentCarfaxRating.vehicleImportedSource
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.vehicleImportedSource) {
         return this.currentInventory.carFaxRating.vehicleImportedSource
      }
      return '-'
    },
    overviewVehicleImportedComments: function () {
      if (this.currentCarfaxRating && this.currentCarfaxRating.vehicleImportedComments) {
        return this.currentCarfaxRating.vehicleImportedComments
      } else if (this.currentInventory && this.currentInventory.carFaxRating && this.currentInventory.carFaxRating.vehicleImportedComments) {
         return this.currentInventory.carFaxRating.vehicleImportedComments
      }
      return '-'
    },
    historyStatusMessage: function () {
      let result = 'A request has been made for history overview, the process is pending.'
      if (this.currentCarfaxRating && this.currentCarfaxRating.historyRequestStatus) {
        if (this.currentCarfaxRating.historyRequestStatus === 'Pending') {
          result = 'A request has been made for history overview, the process is pending.'
        }
        else if (this.currentCarfaxRating.historyRequestStatus === 'Error') {
          result = 'The request to generate a history overview for the current CARFAX has failed, please refresh the CARFAX to automatically generate another request.'
        } 
      }
      return result
    }
  },
  watch: {
    inventoryItem: function (newValue, oldValue) {
      if (newValue) {
        this.currentInventory = newValue
      }
    },
    carFaxRating: function (newValue, oldValue) {
      if (newValue) {
        this.currentCarfaxRating = newValue
      }
    }
  },
  mounted: function () {
    this.currentInventory = this.inventoryItem
    this.currentCarfaxRating = this.carFaxRating
    eventBus.$on('carfax-rating-processing-status-tracker', this.onCarfaxStatusChanged)
  },
  beforeDestroy () {
    eventBus.$off('carfax-rating-processing-status-tracker', this.onCarfaxStatusChanged)
  }
}

</script>

<style scoped>
  .content ul{
    list-style-type: none;
    margin-top: 0
  }

  .modal.is-active .modal-card-foot {
    padding: 10px !important
  }

  .modal-card-head, .modal-card-body{
    padding: 10px !important
  }

  .modal-card .modal-card-body {
    position:relative;
    max-height: 65vh; /* max 80% of the viewport height */
    max-width: 960px; /* max 80% of the viewport height */
    height: unset !important;
    overflow-y: scroll;
  }

  #usage-container {
    display:inline-flex;
    vertical-align: middle;
    align-items: center;
  }

  .table {
    background-color: #f8fafc !important;
    color: #6c6c7a;
    font-size: 0.7rem;
    width: 100%;
  }

</style>
